export default {
  data() {
    return {
      virtualPickerDebounceId: null,
    };
  },

  beforeDestroy() {
    this.clearVirtualPickerDebounce();
  },

  methods: {
    clearVirtualPickerDebounce() {
      if (this.virtualPickerDebounceId) {
        clearTimeout(this.virtualPickerDebounceId);
        this.virtualPickerDebounceId = null;
      }
    },

    debounceVirtualPickerSearch(applyFn, delay = 80) {
      this.clearVirtualPickerDebounce();
      this.virtualPickerDebounceId = setTimeout(() => {
        this.virtualPickerDebounceId = null;
        if (typeof applyFn === 'function') applyFn();
      }, delay);
    },

    clampVirtualPickerIndex(index, total) {
      if (!total || total < 1) return -1;
      if (index < 0) return 0;
      if (index >= total) return total - 1;
      return index;
    },

    ensureVirtualPickerIndexVisible(scrollRef, index, itemHeight = 40, viewportHeight = 320) {
      if (!scrollRef || index < 0) return;
      if (typeof scrollRef.scrollToIndex === 'function') {
        scrollRef.scrollToIndex(index);
        return;
      }
      const el = scrollRef.$el || scrollRef;
      if (!el || typeof el.scrollTop !== 'number') return;
      const top = index * itemHeight;
      const bottom = top + itemHeight;
      if (top < el.scrollTop) {
        el.scrollTop = top;
        return;
      }
      const visibleBottom = el.scrollTop + viewportHeight;
      if (bottom > visibleBottom) el.scrollTop = Math.max(0, bottom - viewportHeight);
    },
  },
};
